import React, { Component } from "react";
import TextareaAutosize from 'react-textarea-autosize';
import Context from "../../../context/Context";
import Topic from "../../../context/Topic";
import * as CrudReply from "../../base/transaction/reply";
import * as commentReplyUtil from "./commentReplyUtil";
import { ButtonGroup } from "../../styles/Common/sort";
import  { ThemeColorButton } from "../../styles/commentsStyles";


export default class EditComment extends Component {

    constructor(props){
        super(props);
        this.state={
            reply: this.props.reply,
            emptyReply: false,
            isCalloutClicked : false
        }
    }

    handleCancel=()=>{
        this.props.cancelClicked();
    }

    handleInputChange =(evt)=> {
        this.setState({
            reply : evt.target.value
        },function(){
            if(!this.state.reply) {
                this.setState({
                    emptyReply : true
                })
            }else{
                this.setState({
                    emptyReply : false
                })
            }
        })
    }

    handleSave = () => {
        const reply = this.state.reply;
        const author = Context.instance.user.getUsername();
        const openPlanId = Context.instance.spaceplanner.planId;
        const commentId = this.props.commentId;
        const objectId = this.props.replyId;
        if(!reply){
            this.setState({
                emptyReply : true
            })
        }else{
            const obj = {
                reply: reply,
                author: author,
                planId: openPlanId,
                commentId: commentId,
                objectId: objectId
            }
            const url = commentReplyUtil.getCommentUrl();
            CrudReply.editReply(obj, url).then(()=>{
                Topic.publish(Topic.LoadComments);
                this.props.cancelClicked();
            })
            .catch(error=>{
              console.error(error);
              Topic.publishErrorUpdatingData(error.message);
            })
        }
    }

    render(){
        const i18n = Context.instance.i18n;
        let showError;
        if(this.state.emptyReply) showError = i18n.spaceplanner.reply.emptyReply;
        return(
            <div style={{display:"flex", flexDirection: "column", alignItems: "flex-end", margin: "0 0.5rem", paddingBottom:"0.5rem"}}>
                <TextareaAutosize 
                    autoFocus
                    style={{width: "97%", borderColor:"#cacaca", padding:"5px", fontFamily: "sans-serif", color:"#323232",}}
                    minRows={2} 
                    value={Context.sanitizeHtml(this.state.reply)}
                    onChange={this.handleInputChange}
                    />
                <div style={{fontSize: "0.8125rem", color: "#808080"}}>{showError}</div>
                <ButtonGroup>
                    <ThemeColorButton onClick={this.handleSave}>{i18n.general.save}</ThemeColorButton>
                    <ThemeColorButton onClick={this.handleCancel}>{i18n.general.cancel}</ThemeColorButton>
                </ButtonGroup>
            </div>
        )
    }

}